function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg35(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.36 70.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4.82,3.35C2.55,5.4.42,8.13.1,9.41c-.32,1.28.14,5.61,1.02,9.62.88,4.01,2.51,15.17,3.62,24.8,2.22,19.19,4.51,26.2,8.77,26.82,2.61.38,2.55.68,2.63-13.32.08-13.12,2.92-27.55,7.56-38.38,1.87-4.36,2.93-8.24,2.6-9.5C25.6,6.81,16.6.85,12.23.14c-2.75-.45-3.92.06-7.4,3.21",
    style: {
      fill: "#010101",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.19,6.92l4.46,3.01-1.86,4.7c-4.21,10.64-4.07,10.46-8.59,9.95-7.22-.81-9.7-2.65-11.15-8.25-1.65-6.4-1.77-5.65,1.48-9.28,5.24-5.87,7.15-5.88,15.67-.13",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.13,25.8c1.4.53,4.17,1.08,6.15,1.21,4.03.27,3.9-1.11,1.15,11.82-.64,3.02-1.24,10.45-1.33,16.5-.2,13.62-.1,12.97-1.77,11.59-1.91-1.59-3.27-7.51-5.07-22.14-.84-6.85-1.77-14.14-2.05-16.2-.57-4.17-.62-4.13,2.92-2.78",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg35);
export default __webpack_public_path__ + "static/media/35.c63707725b1727affe80e09d4359cef8.svg";
export { ForwardRef as ReactComponent };